<template>
  <div id="yonrin-global_header" class="yonrin-mf_finder_container pc tab">
    <nav class="yonrin-global-header-nav" id="yonrin-search">
      <ul class="yonrin-logoarea">
        <li><a class="yonrin-navbar-brand" href="https://www.suzuki.co.jp/car/"><img src="~@/assets/images/yonrin-header/suzuki_logo.png" alt="スズキ株式会社"></a></li>
      </ul>
    </nav>
  </div>
  <div class="yonrin-header">
    <nav class="pc tab yonrin-header_nav">
      <ul class="yonrin-global_nav">
        <li><a href="https://www.suzuki.co.jp/car/lineup/">ライン<br class="tab">アップ</a></li>
        <li><a href="https://www.suzuki.co.jp/dealer/Map/getPref/shop" onClick="s.linkTrackVars=prop13;s.prop13=四輪車トップ conv 販売店検索;s.tl(this, o, 四輪車トップ conv 販売店検索);" target="_blank">販売店<br class="tab">検索</a></li>
        <li><a href="https://www.suzuki.co.jp/car/purchase/democar/" onClick="s.linkTrackVars=prop13;s.prop13=四輪車トップ conv 展示車・試乗車検索;s.tl(this, o, 四輪車トップ conv 展示車・試乗車検索);">展示車・<br class="tab">試乗車検索</a></li>
        <li><a href="https://www.suzuki.co.jp/car/purchase/estimate/" onClick="s.linkTrackVars=prop13;s.prop13=四輪車トップ conv オンライン見積り;s.tl(this, o, 四輪車トップ conv オンライン見積り);">オンライン<br class="tab">見積り</a></li>
        <li><a href="https://krs.bz/suzuki/m?f=166" onClick="s.linkTrackVars=prop13;s.prop13=四輪車トップ conv カタログ請求;s.tl(this, o, 四輪車トップ conv カタログ請求);" target="_blank">カタログ<br class="tab">請求</a></li>
        <li class="yonrin-rightmenu yonrin-small"><a href="https://www.suzuki.co.jp/car/">四輪トップへ<br class="tab">戻る</a></li>
        <li class="yonrin-small"><a href="https://www.suzuki.co.jp/car/buying/">購入を<br class="tab">お考えの方</a></li>
        <li class="yonrin-small"><a href="https://www.suzuki.co.jp/car/afterservice/">オーナー<br class="tab">の方</a></li>
        <li class="yonrin-small"><a href="https://www.suzuki.co.jp/car/entertainment/">スズキを<br class="tab">楽しむ</a></li>
        <li class="yonrin-small"><a href="https://www.suzuki.co.jp/ucar/" target="_blank">中古車<br class="tab">情報</a></li>
        <li class="yonrin-small"><a href="https://www.suzuki.co.jp/recall/" target="_blank">リコール等<br class="tab">情報</a></li>
      </ul>
    </nav>
  </div>
</template>

<script lang="ts">

import { defineComponent, onMounted } from 'vue';
import headerScript from '@/assets/yonrin-header.js';

export default defineComponent({
  setup () {
    onMounted(async() => {
      headerScript.script();
    });

    return {};
  },
});

</script>

<style lang="scss" scoped>

.yonrin-global-header-nav {
  display: flex;
  position: relative;
  z-index: 100;
  height: 50px;
  border-bottom: 1px solid #0e1d61;
  background-color: #ffffff !important;
  justify-content: space-between;
}

.yonrin-logoarea {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
  box-sizing: border-box;
}

.yonrin-logoarea li {
  box-sizing: border-box;
  margin-left: 0.625rem !important;
}

.yonrin-navbar-brand {
  display: inline-block;
  padding: 9px 0;
  margin-right: 18px;
  font-size: 1.25rem;
  line-height: inherit;
  white-space: nowrap;
  color: rgba(0, 0, 0, 0.9);
}

#yonrin-searchArea {
  width: 260px;
  position: relative;
}

#yonrin-serchArea:after {
  content: "";
  display: block;
  clear: both;
}

.yonrin-header {
  background: #fff;
  justify-content: space-between;
  width: 100%;
}

.yonrin-header .yonrin-header_nav {
  border-bottom: 1px solid #c0c0c0;
  font-family: 'icomoon';
}

.yonrin-header .yonrin-header_nav ul.yonrin-global_nav {
  list-style: none;
  display: flex;
  flex-flow: row;
  margin: 0;
  padding: 10px 0;
  align-items: center;
}

.yonrin-header .yonrin-header_nav ul.yonrin-global_nav li a {
  display: flex;
  padding: 0 12px;
  text-decoration: none;
  font-size: 13px;
  line-height: 1.4;
  color: #314059;
  text-align: center;
}

.yonrin-header .yonrin-header_nav ul.yonrin-global_nav li+li a {
  border-left: solid 1px #aaa;
}

.yonrin-header .yonrin-header_nav ul.yonrin-global_nav li.yonrin-rightmenu {
  margin-left: auto;
}
.yonrin-header .yonrin-header_nav ul.yonrin-global_nav li.yonrin-rightmenu a {
  border: none;
}

.yonrin-header .yonrin-header_nav ul.yonrin-global_nav li.yonrin-small a {
  font-size: 11px;
  font-weight: 400;
}

@media (max-width: 1220px) {
  .yonrin-header .yonrin-header_nav ul.yonrin-global_nav {
    padding: 0.81vw 0;
  }

  .yonrin-header .yonrin-header_nav ul.yonrin-global_nav li a {
    padding: 0 0.98vw;
    font-size: 1.089vw;
    line-height: 1.4;
  }

  .yonrin-header .yonrin-header_nav ul.yonrin-global_nav li.yonrin-small a {
    font-size: 0.91vw;
  }
}

</style>